[
  {
    "code": "MT-01",
    "name": "Attard"
  },
  {
    "code": "MT-02",
    "name": "Balzan"
  },
  {
    "code": "MT-03",
    "name": "Birgu"
  },
  {
    "code": "MT-04",
    "name": "Birkirkara"
  },
  {
    "code": "MT-05",
    "name": "Birzebbuga"
  },
  {
    "code": "MT-06",
    "name": "Bormla"
  },
  {
    "code": "MT-07",
    "name": "Dingli"
  },
  {
    "code": "MT-08",
    "name": "Fgura"
  },
  {
    "code": "MT-09",
    "name": "Floriana"
  },
  {
    "code": "MT-10",
    "name": "Fontana"
  },
  {
    "code": "MT-13",
    "name": "Ghajnsielem"
  },
  {
    "code": "MT-14",
    "name": "Gharb"
  },
  {
    "code": "MT-15",
    "name": "Gharghur"
  },
  {
    "code": "MT-16",
    "name": "Ghasri"
  },
  {
    "code": "MT-17",
    "name": "Ghaxaq"
  },
  {
    "code": "MT-11",
    "name": "Gudja"
  },
  {
    "code": "MT-12",
    "name": "Gzira"
  },
  {
    "code": "MT-18",
    "name": "Hamrun"
  },
  {
    "code": "MT-19",
    "name": "Iklin"
  },
  {
    "code": "MT-20",
    "name": "Isla"
  },
  {
    "code": "MT-21",
    "name": "Kalkara"
  },
  {
    "code": "MT-22",
    "name": "Kercem"
  },
  {
    "code": "MT-23",
    "name": "Kirkop"
  },
  {
    "code": "MT-24",
    "name": "Lija"
  },
  {
    "code": "MT-25",
    "name": "Luqa"
  },
  {
    "code": "MT-26",
    "name": "Marsa"
  },
  {
    "code": "MT-27",
    "name": "Marsaskala"
  },
  {
    "code": "MT-28",
    "name": "Marsaxlokk"
  },
  {
    "code": "MT-29",
    "name": "Mdina"
  },
  {
    "code": "MT-30",
    "name": "Mellieha"
  },
  {
    "code": "MT-31",
    "name": "Mgarr"
  },
  {
    "code": "MT-32",
    "name": "Mosta"
  },
  {
    "code": "MT-33",
    "name": "Mqabba"
  },
  {
    "code": "MT-34",
    "name": "Msida"
  },
  {
    "code": "MT-35",
    "name": "Mtarfa"
  },
  {
    "code": "MT-36",
    "name": "Munxar"
  },
  {
    "code": "MT-37",
    "name": "Nadur"
  },
  {
    "code": "MT-38",
    "name": "Naxxar"
  },
  {
    "code": "MT-39",
    "name": "Paola"
  },
  {
    "code": "MT-40",
    "name": "Pembroke"
  },
  {
    "code": "MT-41",
    "name": "Pietà"
  },
  {
    "code": "MT-42",
    "name": "Qala"
  },
  {
    "code": "MT-43",
    "name": "Qormi"
  },
  {
    "code": "MT-44",
    "name": "Qrendi"
  },
  {
    "code": "MT-45",
    "name": "Rabat Gozo"
  },
  {
    "code": "MT-46",
    "name": "Rabat Malta"
  },
  {
    "code": "MT-47",
    "name": "Safi"
  },
  {
    "code": "MT-51",
    "name": "Saint Paul’s Bay"
  },
  {
    "code": "MT-48",
    "name": "San Giljan"
  },
  {
    "code": "MT-49",
    "name": "San Gwann"
  },
  {
    "code": "MT-50",
    "name": "San Lawrenz"
  },
  {
    "code": "MT-52",
    "name": "Sannat"
  },
  {
    "code": "MT-53",
    "name": "Santa Lucija"
  },
  {
    "code": "MT-54",
    "name": "Santa Venera"
  },
  {
    "code": "MT-55",
    "name": "Siggiewi"
  },
  {
    "code": "MT-56",
    "name": "Sliema"
  },
  {
    "code": "MT-57",
    "name": "Swieqi"
  },
  {
    "code": "MT-59",
    "name": "Tarxien"
  },
  {
    "code": "MT-58",
    "name": "Ta’ Xbiex"
  },
  {
    "code": "MT-60",
    "name": "Valletta"
  },
  {
    "code": "MT-61",
    "name": "Xaghra"
  },
  {
    "code": "MT-62",
    "name": "Xewkija"
  },
  {
    "code": "MT-63",
    "name": "Xghajra"
  },
  {
    "code": "MT-64",
    "name": "Zabbar"
  },
  {
    "code": "MT-65",
    "name": "Zebbug Gozo"
  },
  {
    "code": "MT-66",
    "name": "Zebbug Malta"
  },
  {
    "code": "MT-67",
    "name": "Zejtun"
  },
  {
    "code": "MT-68",
    "name": "Zurrieq"
  }
]